import { ZIcon } from "components/ZIcon";
import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";
import { useEffect, useState } from "react";
import { ZIconType } from "helpers/utility/iconMap";

export interface IValidCellRendererParams<T> extends IBaseCellRendererParams<T> {
    validationError?: string;
}

export default function ValidCellRenderer(props: IValidCellRendererParams<boolean>) {
    return (
        <BaseCellRenderer {...props}>
            {props.value != null ? (
                <>
                    {props.value === true && <ZIcon icon={ZIconType.Check} variant="success" />} 
                    {props.value === false && <ZIcon icon={ZIconType.Alert} variant="warning" />}
                    &nbsp;
                    {props.validationError && props.validationError}
            </>) : <></>}
        </BaseCellRenderer>
    );
}